











































































































































































































































































import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { MediaQuery as MQ } from '@/MediaQuery';
import { NavModule, LodgingModule, ProfileModule, BankModule } from "@/store";
import {
  mdbAlert,
  mdbAutocomplete,
  mdbBtn,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbCard,
  mdbCardHeader,
  mdbCardTitle,
  mdbCardBody,
  mdbCardFooter,
  mdbInput,
  mdbRow,
  mdbSpinner
} from "mdbvue";
import { RouterNames } from '@/router/RouterNames'
import { RouterUtils } from '@/router/RouterUtils'
// import { LodgingUnit, LodgingUnitResponse, LodgingUnitsResponse, LodgingUnitUpdateRequest } from '@fgl/funfangle-sdk/dist/rest/lodging';
// import AddTenantShortTerm from './AddStay.vue';
import RequiredLodgingComponent from "@/views/onboarding/RequiredLodgingComponent.vue";
// import AddParticipantComponent from "./AddParticipantComponent.vue";
import ProfilePhoto from "@/components/profiles/ProfilePhotoComponent.vue";
import { Invoice, InvoicesResponse } from "@fgl/funfangle-sdk/dist/rest/bank";
import { BankInvoiceApiClient } from "@/shared/api";
import { DateTime, LocaleOptions } from "luxon";

@Component({
  components: {
    // AddTenantShortTerm,
    // AddParticipantComponent,
    mdbAlert,
    mdbAutocomplete,
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbIcon,
    mdbInput,
    mdbCard,
    mdbCardHeader,
    mdbCardTitle,
    mdbCardBody,
    mdbCardFooter,
    mdbRow,
    mdbSpinner,
    ProfilePhoto,
    RequiredLodgingComponent
  }
})
export default class AccountPropertiesVue extends mixins(RouterUtils) {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  lodgingStore: LodgingModule = getModule(LodgingModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MQ = MQ;
  RouterNames = RouterNames;
  
  activeSection: string = "#loading";
  tableFields: any[] = [{
    key: "label",
    label: "Address",
    sortable: true
  // }, {
  //   key: "actions",
  //   label: "Options",
  //   sortable: false
  }];
  msgAlertInfo: string | null = null;
  msgAlertSuccess: string | null = null;
  msgAlertError: string | null = null;
  // allLodgings: any[] = [];
  // editFirstName: string | undefined = '';
  // editLastName: string | undefined = '';
  // editNameEnabled: boolean = false;
  // isApplyingEdit: boolean = false;
  isLoading: boolean = true;
  isProcessing: boolean = false;
  // isRemoving: boolean = false;
  // selectedLodgingLabel: any = null;

  invoicesDueResponse: InvoicesResponse | null = null;

  get isFormValid(): boolean {
    // if (this.selectedLodgingLabel == null) return false;
    // return this.hasLodging(this.selectedLodgingLabel);
    return true;
  }

  // get lodgings(): LodgingUnit[] {
  //   return this.lodgingStore.userUnits;
  // }

  get invoices(): Invoice[] {
    if (this.invoicesDueResponse == null) return [];
    if (this.invoicesDueResponse.data.code !== 'OK') return [];
    return (this.invoicesDueResponse.data.items || []).sort((a: Invoice, b: Invoice) => {
      if (a === undefined) return 1;
      if (b === undefined) return -1;
      if (a > b) return 1;
      return -1;
    });
  }

  // get paymentMethods() {
  //   return this.profileStore.paymentMethods;
  // }

  // @Watch("paymentMethods")
  // onPaymentMethodsChange() {
  //   if (this.processor === "square") {
  //     this.loadSquareInfo();
  //   }
  // }
  
  // methods: {
  //   ...mapGetters("user", [
  //     "getSquareInfo",
  //     "getOrgId",
  //     "getFirstName",
  //     "getLastName",
  //     "getEmail"
  //   ]),
  //   ...mapGetters("paymentmethods", ["getPaymentMethods"]), // TODO: Is this OBE?
  //   ...mapGetters("bank", ["getOrganization"]),
  //   ...mapActions("user", ["removeSquareCard", "setDefaultSquareCard"]),
  //   ...mapMutations("user", ["setSquareInfo"]),

  // get disabledAdd() {
  //   if (!this.navStore.allowCreateAuthorizedUsers) return true;
  //   if (this.navStore.maxAuthorizedUsers != null && this.navStore.maxAuthorizedUsers >= 6) return true;
  //   return false;
  // }

  // handleAddClick() {
  //   // window.location.hash = 'add';
  //   // this.activeSection = '#add';
  //   this.$router.push({ name: RouterNames.ACCOUNT_AUTHORIZEDUSER_ADD, query: { rtn: RouterNames.ACCOUNT_AUTHORIZEDUSER_LIST } })
  // }
  // handleAddGuestCallback(e: Event) {
  //   // console.log('handleAddGuestCallback !!')
  //   this.$notify.success({message: 'Added guest', position:'top right', timeOut: 7000});
  // }
  // handleAddLodgingCallback(e: Event) {
  //   // console.log('handleAddGuestCallback !!')
  //   this.$notify.success({message: 'Added property', position:'top right', timeOut: 7000});
  //   this.setHash('list');
  // }
  // handleAddGuestClick() {
  //   window.location.hash = 'add-short-term';
  // }
  // handleAddLodgingClick() {
  //   window.location.hash = 'add-property';
  //   this.fetchLodging().catch();
  // }
  // handleGoBackClick() {
  //   window.location.hash = 'list';
  // }
  // makeDefault(rowItem: LodgingUnit, rowIndex: number /*, eventTarget */) {
  //   // TODO
  //   // if (this.processor === "square") {
  //   //   const payload = {
  //   //     squareInfo: this.profileStore.squareInfo,
  //   //     defaultCardId: rowItem.cardId,
  //   //     organizationId: this.profileStore.organizationId,
  //   //     email: this.profileStore.email
  //   //   };
  //   //   this.profileStore.updateDefaultSquareCard(payload).then(res => {
  //   //     this.loadSquareCards();
  //   //   });
  //   // }
  // }
  // /**
  //  * Confirm the removal of the card
  //  */
  // confirmRemoval(rowItem: LodgingUnit, rowIndex: number /*, eventTarget */) {
  //   this.activeSection = "#remove-lodging";
  //   window.location.hash = this.activeSection;
  //   // this.modalRemoveText =
  //   //   this.$tc("phrase.remove_card_ending_in") + ` ${rowItem.last4}?`;
  //   // this.modalRemoveCardId = rowItem.cardId || 'UNSET';
  // }

  createdAt(ms: number): string {
    const dt = DateTime.fromMillis(ms).setLocale(this.navStore.locale).setZone(this.navStore.timeZone);
    return dt.toLocaleString(DateTime.DATETIME_SHORT as LocaleOptions);
  }

  selectItem(p: Invoice): void {
    this.$router.push({ name: RouterNames.INVOICE_MAKE_PAYMENT, params: { invoiceId: p?.invoiceId || '' } })
    // this.navStore.setSelectedUser(p);
    // this.editFirstName = p.firstName;
    // this.editLastName = p.lastName;
    // window.location.hash = 'edit';
  }

  // async fetchLodging() {
  //   const url = `${ApiEndpoints.apiEndpoint}/v2/profile/organization/lodgings?organizationId=${this.profileStore.organizationId}`;
  //   // console.log('fetchLodging url...', url)
  //   this.isLoading = true;
  //   const apiSvc = new ApiService();
  //   await apiSvc
  //     .httpGet(url)
  //     .then((res: LodgingUnitsResponse) => {
  //       // console.log('fetchLodging: ', res)
  //       if (
  //         res !== undefined &&
  //         res.data !== undefined &&
  //         res.data.items !== undefined
  //       ) {
  //         this.allLodgings = res.data.items;
  //         this.allLodgings.sort((a: LodgingUnit, b: LodgingUnit) => (a.label || '') > (b.label || '') ? 1 : -1);
  //       }
  //     })
  //     .catch(
  //       //err => {
  //       // console.log("fetchLodging err:", err);
  //       // resolve(err)
  //       //}
  //     );
  //   this.isLoading = false;
  //   return Promise.resolve();
  // }

  // getLodging(label: string): LodgingUnit | null {
  //   if (this.allLodgings !== undefined) {
  //     for (let l of this.allLodgings) {
  //       if (l.label === label) {
  //         return l;
  //       }
  //     }
  //   }
  //   return null;
  // }

  /** Handle the click event of the 'Next' button */
  // async handleAddLodging(e: any) {
  //   this.msgAlertInfo = null;
  //   this.msgAlertError = null;
  //   if (!this.hasLodging(this.selectedLodgingLabel)) {
  //     this.msgAlertError =
  //       `${this.lingoLodgingName} required. Please select valid match with auto-complete dropdown.`;
  //     return;
  //   }
  //   const lodging = this.getLodging(this.selectedLodgingLabel);
  //   if (!lodging) {
  //     this.msgAlertError =
  //       `${this.lingoLodgingName} required. Could not find lodging associated with selection.`;
  //     return;
  //   }
  //   if (this.profileStore.organizationId === undefined) return;
  //   if (lodging.lodgingId === undefined) return;

  //   this.msgAlertError = null;
  //   this.isProcessing = true;
  //   let isSuccess = false;

  //   const params = new LodgingUnitUpdateRequest(
  //     this.profileStore.organizationId,
  //     lodging.lodgingId
  //   );
  //   params.ownerId = this.profileStore.userId;

  //   const apiSvc = new ApiService();
  //   const url = `${ApiEndpoints.apiEndpoint}/v2/lodging/unit/update`
  //   const response = await apiSvc
  //     .httpPost(url, params)
  //     .catch(() => {
  //       this.isProcessing = false;
  //       // reject(err)
  //     });
  //   this.isProcessing = false;
  //   if (response !== undefined && response.data !== undefined && (response.data.code === 'VERIFIED' || response.data.code === 'OK')) {
  //     isSuccess = true;
  //   }
  //   // console.log("item ", response, isSuccess);

  //   this.activeSection = '#list';
  //   this.isLoading = true;
  //   await this.lodgingStore.fetchHouseholdUnits().catch((e: Error) => {
  //     this.msgAlertError = e.message;
  //   })
  //   this.isLoading = false;
  // }

  // hasLodging(label: string) {
  //   let matchedLodging = this.getLodging(label);
  //   return matchedLodging != null;
  // }

  // get lingoLodgingName() {
  //   const name = this.navStore.lingoLodgingName;
  //   if (name === undefined) return name;
  //   if (name.length <= 1) return name.toUpperCase();
  //   return name.charAt(0).toUpperCase() + name.slice(1).toLocaleLowerCase();
  // }

  // get lodgingLabels() {
  //     let labels = [];
  //     if (this.allLodgings !== undefined) {
  //       for (let l of this.allLodgings) {
  //         labels.push(l.label);
  //       }
  //     }
  //     return labels;
  // }

  // async applyEdit(): Promise<void> {
  //   if (this.navStore.selectedUser == null || this.navStore.selectedUser === undefined) {
  //     // this.errorMessage = 'Participant to be deleted has not been selected';
  //     return;
  //   }
  //   if (this.navStore.selectedUser.userId === undefined) {
  //     // this.errorMessage = 'Participant to be deleted is missing a required ID';
  //     return;
  //   }
  //   const organizationId = this.profileStore.currOrganization.organizationId;
  //   if (organizationId == null || organizationId === undefined) {
  //     // this.errorMessage = 'Missing required organization ID';
  //     return;
  //   }
  //   this.isApplyingEdit = true;
  //   const request = new ParticipantUpdateRequest(this.navStore.selectedUser.userId, organizationId);
  //   request.accountHolderId = this.navStore.selectedUser.accountHolderId as string;
  //   request.firstName = this.editFirstName;
  //   request.lastName = this.editLastName;
  //   // and populate the select dropdown
  //   // console.log('selected user ', this.navStore.selectedUser);
  //   // console.log('request', request);
  //   const url = `${ApiEndpoints.apiEndpoint}/v2/profile/participant`;
  //   const apiSvc = new ApiService();
  //   const res = await apiSvc.httpPost(url, request).catch();
  //   if (!res || res === undefined || res.data === undefined) {
  //     // this.errorMessage = 'Server did not respond';
  //     return;
  //   }
  //   if (res.data.code !== 'OK') {
  //     // this.errorMessage = res.data.message;
  //     return;
  //   }
  //   // console.log('res', res);
  //   await this.profileStore.fetchAllDetails().catch();
  //   this.isApplyingEdit = false;
  //   window.location.hash = 'list';
  //   this.navStore.setSelectedUser(null);
  // }

  // /**
  //  * Perform removal, after the confirmation modal
  //  */
  // async performRemoval(): Promise<void> {
  //   if (this.navStore.selectedUser == null || this.navStore.selectedUser === undefined) {
  //     // this.errorMessage = 'Participant to be deleted has not been selected';
  //     return;
  //   }
  //   if (this.navStore.selectedUser.userId === undefined) {
  //     // this.errorMessage = 'Participant to be deleted is missing a required ID';
  //     return;
  //   }
  //   const organizationId = this.profileStore.currOrganization.organizationId;
  //   if (organizationId == null || organizationId === undefined) {
  //     // this.errorMessage = 'Missing required organization ID';
  //     return;
  //   }
  //   // console.log('handleCheckIn index ', index);
  //   // this.errorMessage = null;
  //   this.isProcessing = true;
  //   // fetch the sessions
  //   const request = new ParticipantUpdateRequest(this.navStore.selectedUser.userId, organizationId);
  //   request.accountHolderId = this.navStore.selectedUser.accountHolderId as string;
  //   request.inactive = true;
  //   // and populate the select dropdown
  //   // console.log('selected user ', this.navStore.selectedUser);
  //   // console.log('request', request);
  //   const url = `${ApiEndpoints.apiEndpoint}/v2/profile/participant`;
  //   const apiSvc = new ApiService();
  //   const res = await apiSvc.httpPost(url, request).catch((err: Error) => {
  //     // this.errorMessage = err.message;
  //   });
  //   this.isProcessing = false;
  //   if (!res || res === undefined || res.data === undefined) {
  //     // this.errorMessage = 'Server did not respond';
  //     return;
  //   }
  //   if (res.data.code !== 'OK') {
  //     // this.errorMessage = res.data.message;
  //     return;
  //   }

  //   // console.log('res', res);

  //   await this.profileStore.fetchAllDetails().catch();
  //   window.location.hash = 'list';
  //   this.navStore.setSelectedUser(null);
  //   // // hide modal
  //   // this.msgAlertInfo = this.modalRemoveText;
  //   // this.isRemoving = true;
  //   // // remove card, if square
  //   // if (this.processor === "square" && this.profileStore.squareInfo !== undefined) {
  //   //   const payload = {
  //   //     cardId: this.modalRemoveCardId,
  //   //     email: this.profileStore.email,
  //   //     organizationId: this.profileStore.organizationId,
  //   //     customerId: this.profileStore.squareInfo.squareCustomerId,
  //   //     squareInfo: this.profileStore.squareInfo
  //   //   };
  //   //   await this.profileStore.removeSquareCard(payload)
  //   //     .then(res => {
  //   //       this.isRemoving = false;
  //   //       this.activeSection = "#list";
  //   //       window.location.hash = this.activeSection;
  //   //       this.msgAlertSuccess = this.$tc("phrase.success_removing_the_card");
  //   //       this.msgAlertInfo = null;
  //   //       // this.squareInfo = this.profileStore.squareInfo;
  //   //       this.loadSquareCards();
  //   //     })
  //   //     .catch((err: Error) => {
  //   //       this.isRemoving = false;
  //   //       this.msgAlertInfo = null;
  //   //       this.msgAlertError =
  //   //         this.$tc("phrase.error_removing_the_card") + err;
  //   //       // console.log("Error removing the card", err);
  //   //     });
  //   // }
  // }

  // loadSquareCards() {
  //   if (
  //     this.profileStore.squareInfo &&
  //     this.profileStore.squareInfo.cards &&
  //     this.profileStore.squareInfo.cards !== undefined
  //   ) {
  //     const cards = this.profileStore.squareInfo.cards;
  //     this.tableItems = cards.map(card => {
  //       const details = new PaymentMethod();
  //       details.type = card.squareCardType;
  //       details.last4 = `xxxxxx${card.squareCardLast4}`;
  //       details.cardId = card.squareCardId;
  //       if (this.profileStore.squareInfo !== undefined) {
  //         details.status =
  //           card.squareCardId === this.profileStore.squareInfo.defaultCardId
  //             ? "Default"
  //             : "";
  //         details.isDefault = card.squareCardId === this.profileStore.squareInfo.defaultCardId;
  //       }
  //       return details;
  //     });
  //   }
  // }
  // async loadSquareInfo() {
  //   // console.log("Load square info...");
  //   // this.squareInfo = this.getSquareInfo()
  //   // console.log(this.squareInfo)
  //   const sqUtil = new SquareUtils();
  //   await sqUtil.validateSqCust()
  //     .then(res => {
  //       // this.profileStore.setSquareInfo(res.data.message.Attributes.squareInfo);
  //       // this.squareInfo = this.profileStore.squareInfo;
  //       this.activeSection = "#list";
  //       window.location.hash = this.activeSection;
  //       this.squareLoadError = "";
  //       this.loadSquareCards();
  //     })
  //     .catch(err => {
  //       if (err && err.message !== "Already initialized square") {
  //         if (err.response) {
  //           // The request was made and the server responded with a status code
  //           // that falls out of the range of 2xx
  //           // console.log(err.response.data);
  //           // console.log(err.response.status);
  //           // console.log(err.response.headers);
  //         } else {
  //           // console.log("create square customer err:", err);
  //         }
  //         this.activeSection = "#load-error";
  //         window.location.hash = this.activeSection;
  //         this.squareLoadError =
  //           `Payment processor is not available. ${err.message}. Please try again later.`;
  //       } else {
  //         // console.log("... square already loaded.");
  //         this.loadSquareCards();
  //       }
  //     });
  // }

  rowStyle(index: number) {
    if (index % 2 === 0) {
      return "background: #f0f0f0";
    }
    return "";
  }

  setHash(hash: string): void {
    window.location.hash = hash;
  }

  async mounted(): Promise<void> {
    // this.navStore.setSelectedUser(null);
    this.msgAlertError = null;
    this.activeSection = '#list';
    // if (window.location.hash !== '' && window.location.hash !== '#list') {
    //   window.location.hash = this.activeSection;
    // }
    this.isLoading = true;
    const apiSvc = new BankInvoiceApiClient();
    apiSvc.getAccountInvoicesDue()
      .then((rs: InvoicesResponse) => {
        this.invoicesDueResponse = rs;
        this.isLoading = false;
      })
      .catch((e: Error) => {
        this.isLoading = false;
        this.msgAlertError = e.message;
      })
    // await this.lodgingStore.fetchHouseholdUnits().catch((e: Error) => {
    //   this.msgAlertError = e.message;
    // })
    // this.isLoading = false;
  }

  // @Watch("$route", { immediate: true, deep: true })
  // onRouteChange(newRoute: any, oldRoute: any): void {
  //   // console.log("deposits route", this.$route, oldVal, newVal);
  //   if (oldRoute != undefined && newRoute.hash !== oldRoute.hash) {
  //     if (newRoute.hash !== '') {
  //       this.activeSection = newRoute.hash
  //     } else {
  //       this.activeSection = '#list';
  //     }
  //   }
  // }
}
